import {getFromCookie} from '../utils/storage';

// Rather empty service, but will get bigger with DMOI
export function getUserId(): string {
	return getFromCookie('authId');
}
